// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4188":"6de1b9da9a99102b","4653":"95fecc9d64cb815a","5639":"fa9efe8038d38a15","5957":"71ce681bf48a93a9","6796":"92401798329b51a2"}[chunkId] + ".css";
};